module.exports = {
  getMessage: () => 'Nome errado. O formato correto deve ser o Primeiro e último nome.',
  validate: (value) => {
    var res = value.split(' ')
    if (res.length - 1 === 1 && res[1] !== '' && value.match(/\d+/g) == null) {
      return true
    } else {
      return false
    }
  }
}
